var _circle, _circle2, _circle3, _rect, _polygon, _rect2, _rect3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFederalMinistryFinance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    fill: "#ffffff",
    stroke: "#2d5016",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 40,
    fill: "#2d5016"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 35,
    fill: "#ffffff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 30,
    width: 20,
    height: 25,
    fill: "#2d5016"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50,25 45,35 55,35",
    fill: "#dc2626"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 55,
    width: 30,
    height: 3,
    fill: "#2d5016"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 60,
    width: 30,
    height: 3,
    fill: "#2d5016"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 80,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 8,
    fill: "#2d5016",
    fontWeight: "bold"
  }, "FMF")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFederalMinistryFinance);
export default __webpack_public_path__ + "static/media/federal-ministry-finance.dee6638f8a8530cd8c544d684bda76ba.svg";
export { ForwardRef as ReactComponent };